// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ul-0";
export var checkoutRateBadgeLink = "_ul-1";